let cart_items = [];
window.addEventListener("load", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const orderNo = urlParams.get("orderNo");
  const al_ain_id = document.getElementById("user_id").value;
  const customer_email = document.getElementById("customer_email").value;
  const langAttribute = document.documentElement.getAttribute("lang");

  if (!al_ain_id || !customer_email || !orderNo) {
    window.location.href = "/account";
    return false;
  }

  let card_payment_text = "Payment by Credit/Debit Card";
  let wallet_payment_text = "Payment by Wallet";
  let cod_payment_text = "Cash On Delivery (COD)";
  let partial_payment_text = "Payment by Wallet & Credit/Debit Card";
  let unknown_payment_text = "Unknown Payment Type";
  let something_went_wrong_text = "Something went wrong. Please try again.";
  let subtotal_text = "Subtotal •";
  let items_text = "items";
  let vat_txt = "VAT";

  if (langAttribute == "ar") {
    card_payment_text = "الدفع عن طريق بطاقة الائتمان/الخصم";
    wallet_payment_text = "الدفع عن طريق المحفظة";
    cod_payment_text = "الدفع عند الاستلام (COD)";
    partial_payment_text = "الدفع عن طريق المحفظة وبطاقة الائتمان/الخصم";
    unknown_payment_text = "نوع الدفع غير معروف";
    something_went_wrong_text = "حدث خطأ ما. يرجى المحاولة مرة أخرى.";
    subtotal_text = "المجموع الفرعي •";
    items_text = "أغراض";
    vat_txt = "ضريبة";
  }

  if (orderNo) {
    // document.getElementById("orderNo").textContent = orderNo;
    cartClear();
    shopifyRequest("GET", `/orders/${orderNo}.json`)
      .then((orderdata) => {
        cartClear();
        // console.log("shopifydata order =>", orderdata);
        const order = orderdata.order;
        let transaction_id =
          Array.isArray(order.note_attributes) &&
            order.note_attributes.length > 1 &&
            order.note_attributes[1]?.value
            ? order.note_attributes[1].value
            : "";
        document.getElementById("cureent-order-number").textContent =
          order.order_number;
        cart_items = order.line_items.map((item) => ({
          item_id: item.id,
          item_name: item.name,
          quantity: item.quantity,
          price: item.price,
        }));

        const bottleDepAmt = order.line_items
          .filter((item) => item.sku === "BOTTLE_DEPOSIT")
          .map((item) => item.price);

        //      document.getElementById("bottle-deposit").textContent =
        // bottleDepAmt.length > 0 ? `${bottleDepAmt.join(", ")} AED` : "0 AED";
        const totalBottleDeposit =
          bottleDepAmt.length > 0
            ? bottleDepAmt.reduce((sum, price) => sum + parseFloat(price), 0)
            : 0;
        const totalAmount =
          parseFloat(order.current_total_price) + totalBottleDeposit;
        const subtotalAmount =
          parseFloat(order.current_subtotal_price) - totalBottleDeposit;

        dataLayerPushPurchase(transaction_id, order.current_total_price);

        const { email, first_name, id, last_name } = order.customer;
        // Payment Method
        const tags = order.tags.split(",").map((tag) => tag.trim());
        const paymentTypeElement = document.getElementById("payment_type");
        document.getElementById(
          "subtotal_amount"
        ).textContent = `${subtotalAmount.toFixed(2)} AED`;
        document.getElementById("total_amount").textContent =
          totalAmount.toFixed(2);
        if (tags.includes("MG")) {
          paymentTypeElement.textContent = card_payment_text;
          let paymentData = {
            type: "MagnatiCard",
            order_amount: order.current_total_price,
            tags: "MG",
            order: {
              id: order.id,
              order_no: order.order_number,
            },
            customer: {
              id: id,
              email: email,
              first_name: first_name,
              last_name: last_name,
            },
          };

          updateShopifyPayment(paymentData);
        } else if (tags.includes("Wallet")) {
          paymentTypeElement.textContent = wallet_payment_text;
          let paymentData = {
            type: "Wallet",
            order_amount: order.current_total_price,
            tags: "Wallet",
            order: {
              id: order.id,
              order_no: order.order_number,
            },
            customer: {
              id: id,
              email: email,
              first_name: first_name,
              last_name: last_name,
            },
          };

          updateShopifyPayment(paymentData);
        } else if (tags.includes("COD")) {
          paymentTypeElement.textContent = cod_payment_text;
          let paymentData = {
            type: "COD",
            order_amount: order.current_total_price,
            tags: "COD",
            order: {
              id: order.id,
              order_no: order.order_number,
            },
            customer: {
              id: id,
              email: email,
              first_name: first_name,
              last_name: last_name,
            },
          };

          updateShopifyPayment(paymentData);
        } else if (tags.includes("MGWallet")) {
          paymentTypeElement.textContent = partial_payment_text;
          let paymentData = {
            type: "partialPayment",
            order_amount: order.current_total_price,
            tags: "MGWallet",
            wallet_amount: order.note_attributes[3].value,
            card_amount: order.note_attributes[4].value,
            order: {
              id: order.id,
              order_no: order.order_number,
            },
            customer: {
              id: id,
              email: email,
              first_name: first_name,
              last_name: last_name,
            },
          };

          updateShopifyPayment(paymentData);
        } else {
          paymentTypeElement.textContent = unknown_payment_text;
        }

        // Cart Summary
        const cartSummaryElement = document.querySelector(".cart-info-inner");
        const totalDetailedElement = document.querySelector(
          ".totalDetailed .Titlewrapper"
        );
        const subTotalDetailedElement = document.querySelector(
          ".totalDetailed .sub-total-amt"
        );
        const vatTaxElement = document.querySelector(".totalDetailed.vat-tax");

        const lineItemsCount = order.line_items.filter(
          (item) => item.sku !== "BOTTLE_DEPOSIT"
        ).length;
        const defaultSvg = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.5 7a1.5 1.5 0 1 0-.001-3.001 1.5 1.5 0 0 0 .001 3.001"></path><path fill-rule="evenodd" d="M7.018 1.5h1.964c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366.706.36 1.28.933 1.64 1.639.226.444.32.924.365 1.47.043.531.043 1.187.043 2v1.964c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.76 3.76 0 0 1-1.638 1.64c-.445.226-.925.32-1.471.365-.531.043-1.187.043-2 .043h-1.964c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.76 3.76 0 0 1-1.64-1.638c-.226-.445-.32-.925-.365-1.471-.043-.531-.043-1.187-.043-2v-1.964c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47.36-.706.933-1.28 1.639-1.64.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043m-1.877 1.538c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v1.429l.723-.868a1.75 1.75 0 0 1 2.582-.117l2.695 2.695 1.18-1.18a1.75 1.75 0 0 1 2.604.145l.216.27v-2.374c0-.852 0-1.447-.038-1.91-.037-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.984-.984c-.197-.1-.458-.17-.912-.207-.462-.037-1.057-.038-1.909-.038h-1.9c-.852 0-1.447 0-1.91.038Zm-2.103 7.821-.006-.08.044-.049 1.8-2.159a.25.25 0 0 1 .368-.016l3.226 3.225a.75.75 0 0 0 1.06 0l1.71-1.71a.25.25 0 0 1 .372.021l1.213 1.516q-.032.09-.07.165c-.216.423-.56.767-.984.983-.197.1-.458.17-.912.207-.462.037-1.057.038-1.909.038h-1.9c-.852 0-1.447 0-1.91-.038-.453-.037-.714-.107-.911-.207a2.25 2.25 0 0 1-.984-.984c-.1-.197-.17-.458-.207-.912"></path></svg>
          `;
        const cartProducts =
          JSON.parse(localStorage.getItem("cartProducts")) || [];

        cartSummaryElement.innerHTML = `
        ${order.line_items
            .filter((item) => item.sku !== "BOTTLE_DEPOSIT")
            .map((item) => {
              const matchingProduct = cartProducts.find(
                (product) => product.title === item.title
              );
              const productImage = matchingProduct?.image || defaultSvg;

              return `
              <div class="cart-item">
                <div class="productImage">
                  ${productImage.startsWith("http")
                  ? `<img src="${productImage}" alt="${item.title}">`
                  : productImage
                }
                  <div class="qty-outer">${item.quantity}</div>
                </div>
                <div class="description">${item.title}</div>
                <div class="total-price">${item.price} AED</div>
              </div>
            `;
            })
            .join("")}
      `;

        totalDetailedElement.textContent = `${subtotal_text} ${lineItemsCount} ${items_text}`;
        // subTotalDetailedElement.textContent = `${order.subtotal_price} AED`;
        vatTaxElement.innerHTML = `
        <span class="Titlewrapper">${vat_txt}</span>
        ${order.current_total_tax} AED
      `;
        document.querySelectorAll(
          ".totalPrice strong"
        )[1].textContent = `${order.current_total_price} AED`;
      })
      .catch((error) => {
        console.error("Unable to fetch order number =>", error);
      });
  }

  document
    .getElementById("continue-shopping")
    .addEventListener("click", function () {
      window.location.href = "/collections/all";
    });
});

function cartClear() {
  setTimeout(function () {
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          console.log("Cart cleared successfully.");
        } else {
          console.error("Failed to clear the cart.");
          alert(something_went_wrong_text);
        }
      })
      .catch((error) => {
        console.error("Error clearing the cart =>", error);
        alert(something_went_wrong_text);
      });
  }, 500);
}

function updateShopifyPayment(paymentData, lancode = "en") {
  if (!paymentData || typeof paymentData !== "object") {
    console.error("Invalid paymentData provided.");
    return;
  }

  customApiRequest("/shopifyApiv4/getShopifyPayment", "POST", {}, paymentData)
    .then((response) => {
      if (response?.status == "200") {
        // console.log("Payment updated successfully:", response.data);
      } else {
        console.warn("Payment update failed =>", response?.message || "Unknown error");
      }
    })
    .catch((error) => {
      console.error("Error Updating Shopify payment =>", error.message || error);
    });
}

function dataLayerPushPurchase(tid, price) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "purchase",
    ecommerce: {
      transaction_id: tid, // Replace dynamically with the transaction ID
      affiliation: "Shopify Store", // Replace dynamically
      value: price,
      currency: "AED", // Replace with the store's currency
      items: cart_items,
    },
  });
}
